module.exports = "<table class=\"standardtable wechselnd\">\r\n\t<tr class=\"description\">\r\n    \t<td><%= $._('interface.log.table.coldescription.loginfo') %></td>\r\n    </tr>\r\n\t\r\n</table>\r\n<div class=\"scrollarea\">\r\n<table class=\"standardtable wechselnd\">\r\n\t\r\n</table>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/interface/templates/finished_log_view.template
// module id = 528
// module chunks = 51